import React from 'react';

import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { ContextualAnalyticsData, SCREEN } from '@atlassian/jira-product-analytics-bridge';
import { BacklogButtonVariant } from './backlog-button-variant/view.tsx';
import { BacklogButtonRefresh } from './backlog-button-refresh/view.tsx';
import { useIsExperimentEligible } from './backlog-button-refresh/eligibility.tsx';

export const WhiteboardsTouchpoint = () => {
	const { flow, isVariantEligible } = useIsExperimentEligible();

	return (
		<JSErrorBoundary
			id="whiteboards-touchpoint"
			packageName="jira-software-backlog"
			teamName="starburst"
		>
			<ContextualAnalyticsData
				sourceName="planOnWhiteboardBacklogButton"
				sourceType={SCREEN}
				attributes={{
					growthInitiative: 'cross-flow',
				}}
			>
				{isVariantEligible ? <BacklogButtonRefresh flow={flow} /> : <BacklogButtonVariant />}
			</ContextualAnalyticsData>
		</JSErrorBoundary>
	);
};
